import themeListV from './list-v.js'

let themeList = [
    {
        title: '梦幻黑',
        name: 'black',
        preview: 'image/theme/black/preview@2x.png'
    },
    {
        title: '绀青',
        name: 'dark-blue',
        preview: 'image/theme/dark-blue/preview@2x.png'
    },
    {
        title: '企业蓝',
        name: 'blue',
        preview: 'image/theme/blue/preview@2x.png'
    },
    {
        title: '清新绿',
        name: 'green',
        preview: 'image/theme/green/preview@2x.png'
    },
    {
        title: '经典',
        name: 'd2',
        preview: 'image/theme/d2/preview@2x.png'
    },
    {
        title: '紫罗兰',
        name: 'violet',
        preview: 'image/theme/violet/preview@2x.png'
    },
    {
        title: '简约线条',
        name: 'line',
        backgroundImage: 'image/theme/line/bg.jpg',
        preview: 'image/theme/line/preview@2x.png'
    },
    {
        title: '流星',
        name: 'star',
        backgroundImage: 'image/theme/star/bg.jpg',
        preview: 'image/theme/star/preview@2x.png'
    },
    {
        title: 'Tomorrow Night Blue (vsCode)',
        name: 'tomorrow-night-blue',
        preview: 'image/theme/tomorrow-night-blue/preview@2x.png'
    }
]

export default [...themeListV,...themeList]
